import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  originalStrategies: []
};

const mySpaceSlicer = createSlice({
  name: 'mySpace',
  initialState,
  reducers: {
    setOriginalStrategies: (state, action) => {
      state.originalStrategies = action.payload;
    }
  },
  reset : () => initialState
});

export const { setOriginalStrategies } = mySpaceSlicer.actions;
export default mySpaceSlicer.reducer;

